// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-0c5870a8]{width:100%;height:100%}.main-area[data-v-0c5870a8]{display:flex;flex-flow:row wrap}", ""]);
// Exports
module.exports = exports;
